angular.module('galilai.creator').controller('DesignKindController', function (api, $timeout, $scope, $rootScope) {

    $scope.project = null;
    $scope.isFocusPro = false
    // No mobile os exemplos ficam recolhidos para o modal caber sem rolagem longa.
    $scope.examples = { standard: false, professional: false }

    $rootScope.$on('generator.designKind.show', (event, data) => {
        angular.element('#post-design-kind-modal').modal('show')
        $scope.project = data.project;
        $scope.isFocusPro = data.focus == 'sales'
        $scope.examples = { standard: false, professional: false }
        $rootScope.refreshCreditsBalance()
    })

    $scope.chooseTemplate = function() {
        angular.element('#post-design-kind-modal').modal('hide');
        $rootScope.$broadcast('generate.chooseModes')
        $scope.saveDesignKind('template')
    }

    $scope.saveDesignKind = function(kind) {
        if (!$scope.project) return;
        api.updateProjectGlobalSingle($scope.project, {
            'designKind': kind
        }).catch((err) => {})
    }

    $scope.chooseCreative = function() {
        angular.element('#post-design-kind-modal').modal('hide');
        $rootScope.$broadcast('generator.chooseMode.professional')

        $scope.saveDesignKind('creative')
    }
})